
export default {
  name: 'Label',

  props: {
    tag: {
      type: String,
      default: 'label'
    },

    isInline: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'sm',
      validator: value => ['xs', 'sm', 'md', 'lg'].includes(value)
    }
  },

  computed: {
    compClasses() {
      return [`text-${this.size}`, this.isInline ? 'inline' : 'block']
    }
  }
}
